jQuery(document).ready(function(){
	
	// Show/Hide access key
	jQuery('#showHideLink').on('click', function(){
		jQuery('#spbc_key').val(jQuery('#spbc_key').attr('key'));
		jQuery('#spbc_key+div').show();
		jQuery(this).fadeOut(300);
	});
	
	// Set time zone filed value if key is bad
	if( !+spbcSettings.key_is_ok ){
		var d = new Date();
		jQuery('#spbc_admin_timezone').val(d.getTimezoneOffset()/60*(-1));	
	}
	
});